// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryCarouselAd-cls1_g-a","cls2":"PodcastLibraryCarouselAd-cls2_hiJ PodcastLibraryCarouselAd-cls1_g-a"};